import React, { useState } from "react";
import Joi from "joi-browser";
import SecurityQuestion from "./SecurityQuestion";
import ThankYou from "./ThankYou";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import {
  useVerifyUserByUserNameMutation,
  useLazySendSecurityCodeToEmailQuery,
  useLazySendSecurityCodeToPhoneQuery,
  useLazyVerifySecurityCodeQuery,
} from "../../app/store/authApiSlice";

const ForgotPwd = ({ handlePwdBack, urlData, forgotType }) => {
  const [securityQuestion, setSecurityQuestion] = useState(false);
  const [pwdBlock, setPwdBlock] = useState(true);
  const [secQuestion, setSecQuestion] = useState("");
  const [emailAuth, setEmailAuth] = useState(false);
  const [phoneAuth, setPhoneAuth] = useState(false);
  const [securityAuth, setSecurityAuth] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [questionAuth, setQuestionAuth] = useState(false);
  const [sendCodeBtnLoding, setSendCodeBtnLoding] = useState(false);
  const [verifyBtnLoding, setVerifyBtnLoding] = useState(false);
  const [reSendCodeBtnLoding, setReSendCodeBtnLoding] = useState(false);
  const [reSendCodeMsg, setReSendCodeMsg] = useState(false);

  const [verifyUserByUserName] = useVerifyUserByUserNameMutation();
  const [sendSecurityCodeToEmail] = useLazySendSecurityCodeToEmailQuery();
  const [sendSecurityCodeToPhone] = useLazySendSecurityCodeToPhoneQuery();
  const [verifySecurityCode] = useLazyVerifySecurityCodeQuery();

  const schema = {
    //username: Joi.string().required().label("User Name"),
    //userType: Joi.string().required().label("User Type"),
    email: Joi.string().email().required().label("Email"),
  };

  const handleSecurityQuestion = (question) => {
    setSecurityQuestion(true);
    setPwdBlock(false);
    setSecQuestion(question);
  };

  const handleQuestionBack = () => {
    setSecurityQuestion(false);
    setQuestionAuth(true);
    setPwdBlock(true);
  };

  const doSubmit = async () => {
    const { data: result } = await verifyUserByUserName(stateData);
    if (result !== null && result !== "") {
      handleSecurityQuestion(result);
    } else {
      setStateErrors({ ...stateErrors, username: "Invalid Details" });
    }
  };

  const handleEmailAuth = () => {
    setEmailAuth(true);
    setPhoneAuth(false);
    setStateErrors({});
    setStateData({});
  };
  const handlePhoneAuth = () => {
    setPhoneAuth(true);
    setEmailAuth(false);
    setStateErrors({});
    setStateData({});
  };

  const handleSecurityCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    if (data["userName"] === "" || data["userName"] === undefined) {
      errors["userName"] = "Please enter username";
      setStateErrors(errors);
    } else if (
      data["email"] === "" ||
      (data["email"] === undefined && emailAuth)
    ) {
      errors["email"] = "Please enter email";
      setStateErrors(errors);
    } else if (
      data["phone"] === "" ||
      (data["phone"] === undefined && phoneAuth)
    ) {
    } else {
      setSendCodeBtnLoding(true);
      if (emailAuth && !phoneAuth) {
        const { data: result } = await sendSecurityCodeToEmail({
          username: data["userName"],
          email: data["email"],
          type: forgotType,
        });

        if (result === "fail") {
          errors["email"] = "Invalid Details";
          setStateErrors(errors);
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
        }
      }

      if (phoneAuth && !emailAuth) {
        const { data: result } = await sendSecurityCodeToPhone({
          username: data["userName"],
          phone: data["phone"],
          type: forgotType,
        });

        if (result === "fail") {
          errors["phone"] = "Invalid Details";
          setStateErrors(errors);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
        }
      }
    }
  };

  const handleVerifyCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    if (data["securityCode"] === "" || data["securityCode"] === undefined) {
      errors["securityCode"] = "Please enter security code";
      setStateErrors(errors);
    } else {
      setVerifyBtnLoding(true);
      let email = data["email"];
      if (phoneAuth) email = data["phone"];
      const { data: result } = await verifySecurityCode({
        email,
        code: data["securityCode"],
        type: "pwd",
      });
      if (result === "success") {
        setThankYou(true);
        setPwdBlock(false);
        setVerifyBtnLoding(true);
        setStateErrors({});
      } else {
        errors["securityCode"] = "Invalid Code";
        setStateErrors(errors);
        setVerifyBtnLoding(false);
      }
    }
  };

  const handleQuestionAuth = () => {
    setQuestionAuth(true);
    setEmailAuth(false);
    setPhoneAuth(false);
    setStateData({});
  };

  const handleBack = () => {
    if (!securityAuth && emailAuth) {
      setEmailAuth(!emailAuth);
    }
    if (!securityAuth && phoneAuth) {
      setPhoneAuth(!phoneAuth);
    }
    if (!securityAuth && questionAuth) {
      setQuestionAuth(!questionAuth);
    }

    if (emailAuth || phoneAuth || questionAuth) setSecurityAuth(false);
    else handlePwdBack();
  };

  const handleResendCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    setReSendCodeBtnLoding(true);
    if (emailAuth && !phoneAuth) {
      const { data: result } = await sendSecurityCodeToEmail({
        username: data["userName"],
        email: data["email"],
        type: forgotType,
      });
      if (result === "fail") {
        errors["email"] = "Invalid Details";
        setStateErrors(errors);
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }

    if (phoneAuth && !emailAuth) {
      const { data: result } = await sendSecurityCodeToPhone({
        username: data["userName"],
        phone: data["phone"],
        type: forgotType,
      });
      if (result === "fail") {
        errors["phone"] = "Invalid Details";
        setStateErrors(errors);
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      {pwdBlock && (
        <div className="row">
          <div className="form-group col-md-12">
            <button className="btn btn-link login-back" onClick={handleBack}>
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>

          {questionAuth && (
            <React.Fragment>
              <div className="col-md-12">
                {renderInput("username", "Enter Your Username")}
              </div>
              <div className="col-md-12">
                {renderInput("email", "Enter Your Registered Email")}
              </div>
              <div className="col-md-12">
                <button
                  className="btn btn-outline-default w-100"
                  disabled={!!validate()}
                  onClick={handleSubmit}
                >
                  <i className="fa fa-arrow-right mr-2" aria-hidden="true"></i>
                  Next
                </button>
              </div>
            </React.Fragment>
          )}

          {!emailAuth && !phoneAuth && !questionAuth && (
            <div className="col-md-12 text-center">
              <h2 className="mb-3">Verify Your Identity</h2>
              <p>
                You will now be required to enter One-Time Security Code to
                verify your identity.
              </p>
              <br />
              <h5>How would you like to receive the code?</h5>
              <br />
              <button
                className="btn btn-outline-default mr-2"
                onClick={handleEmailAuth}
              >
                <i className="fa fa-envelope mr-2" aria-hidden="true"></i>
                Send To My Email
              </button>
              {/* <button
                className="btn btn-outline-default"
                onClick={handlePhoneAuth}
              >
                Text To My Mobile
              </button> */}
              <button
                className="btn btn-outline-default"
                onClick={handleQuestionAuth}
              >
                <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                Security Question
              </button>
            </div>
          )}
          {(emailAuth || phoneAuth) && (
            <div className="col-md-12">
              {renderInput("userName", "Enter Your Username")}
            </div>
          )}
          {emailAuth && (
            <div className="col-md-12">
              {renderInput("email", "Enter Your Registered Email")}
            </div>
          )}
          {/* {phoneAuth && (
            <div className="col-md-12">
              {renderInput(
                "phone",
                "Enter Your Registered Mobile Number"
              )}
            </div>
          )} */}
          {securityAuth && (
            <div className="col-md-12">
              {renderInput(
                "securityCode",
                "Enter Your Code Below To Continue"
              )}
            </div>
          )}
          {(emailAuth || phoneAuth) && !securityAuth && (
            <div className="col-md-12 text-center">
              <button
                className="btn btn-outline-default"
                disabled={sendCodeBtnLoding}
                onClick={handleSecurityCode}
              >
                {sendCodeBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-paper-plane mr-2" aria-hidden="true"></i>
                )}
                Send Security Code To My {emailAuth && " email"}
                {phoneAuth && " mobile"}
              </button>
            </div>
          )}
          {securityAuth && (
            <div className="col-md-12 text-center">
              <button
                className="btn btn-outline-default"
                disabled={verifyBtnLoding}
                onClick={handleVerifyCode}
              >
                {verifyBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-check mr-2" aria-hidden="true"></i>
                )}
                Verify
              </button>
              <br />
              <br />
              <p>Didn't receive the code?</p>
              <button
                className="btn btn-sm btn-link pl-0"
                disabled={reSendCodeBtnLoding}
                onClick={handleResendCode}
              >
                {reSendCodeBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Resend Code
              </button>
              {reSendCodeMsg && (
                <span className="text-red">
                  Security Code Sent Successfully
                </span>
              )}
            </div>
          )}
        </div>
      )}
      {thankYou && <ThankYou forgotType="pwd" urlData={urlData}></ThankYou>}
      {securityQuestion && (
        <SecurityQuestion
          handleQuestionBack={handleQuestionBack}
          secQuestion={secQuestion}
          userType={stateData["userType"]}
          forgotType="pwd"
          urlData={urlData}
        ></SecurityQuestion>
      )}
    </React.Fragment>
  );
};

export default ForgotPwd;
